/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, NgZone, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './top-articles-screenshotting-modal.component.html';
import {ApiConfig} from '../../../components/api/api';
import {AdnShotterService} from '../adn-shotter.service';

export interface TopArticlesScreenshottingResult {
  hasQueued: boolean;
}

@Component({
  standalone: false,
  selector: 'adn-top-articles-screenshotting-modal',
  template
})
export class TopArticlesScreenshottingModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  object: any;
  children: any[] = [];
  articles: string[] = [];
  networkTag = '';

  readonly onTriggered = new Subject<TopArticlesScreenshottingResult>();

  readonly specialLineItemId = 'line-item-id-for-screenshotter';
  device = 'DESKTOP';
  creatives: any[] = [];
  theCreativeId: string;
  theScript = '';
  triggered = false;

  constructor(
    public bsModalRef: BsModalRef,
    private readonly ngZone: NgZone,
    private readonly adnShotter: AdnShotterService
  ) {
  }

  ngOnInit(): void {
    this.creatives = [{
      name: 'Most suitable from line item',
      id: this.specialLineItemId
    }];
    _.forEach(this.children || [], (c) => {
      if (c.objectState === 'ACTIVE') {
        this.creatives.push({
          name: c.name,
          width: c.width,
          height: c.height,
          id: c.id
        });
      }
    });
    this.theCreativeId = this.creatives[0].id;
    this.updateScript();
  }

  updateScript(): void {
    const theChildren = [];
    _.forEach(this.children || [], (c) => {
      if (c.objectState === 'ACTIVE' && (this.theCreativeId === this.specialLineItemId || c.id === this.theCreativeId)) {
        theChildren.push({
          cId: c.id,
          w: c.width,
          h: c.height
        });
      }
    });
    const env = ApiConfig.obtain().getId().replace('_adn', '');
    this.theScript = 'var scriptEl = document.createElement("script");scriptEl.src=("https://cdn.adnuntius.com/shotter.js?env=' + env + '&cjson=' + encodeURIComponent(JSON.stringify(theChildren)) + '&networkId=' + this.networkTag + '");document.body.appendChild(scriptEl);';
  }

  triggerScreenshot(): void {
    const creativeId = this.theCreativeId === this.specialLineItemId ? null : this.theCreativeId;
    const lineItemId = this.theCreativeId === this.specialLineItemId ? this.object.id : null;

    const allPromises = [];
    _.forEach(this.articles, (article) => {
      allPromises.push(this.adnShotter.takeShot(creativeId, lineItemId, article, this.device));
    });
    this.triggered = true;
    Promise.all(allPromises).then(() => {
      this.ngZone.run(() => {
        this.onTriggered.next({hasQueued: true});
      });
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
